// 存在sessionStorage中用于获取登陆态相关信息的key
export const LOGINED = 'logined'
export const USER = 'USER'
export const Y = 'y'
export const N = 'n'
export const NO_USER_TOKEN_STATUS_CODE_GATEWAY = 400
export const NO_USER_TOKEN_STATUS_CODE_SERVER = 401
export const SUCCESS_STATUS_CODE = 200
export const SERVER_ERROR_STATUS_CODE = 500
export const EXCEPTION_MSG = '系统异常，请稍后再试！'
// 神策埋点url
export const SENSORS_TRACK_URL = 'https://sensorsdata.ppdai.com/sa/'
// 客服url
export const KEFU_HELP_URL = 'https://kefu.ppdai.com/'

// 请求接口的方式
export const REQUEST_METHOD_GET = 'get'
export const REQUEST_METHOD_POST = 'post'

// 站点重定向链接
export const REDIRECT_URL = 'https://mktmgm.ppdai.com/mgm_eighth?needAuth=true&from=weiliang'
